export default {"src":"/_next/static/media/loading.a71c8125.gif","height":150,"width":150};